/**
 * @generated SignedSource<<5532a98efe35505ae6a051d6e2893b72>>
 * @relayHash 978334c7a56389878fe12e353224c5fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b52b2cd2f09302e89f948c3933b5eded67abf62d74d6bcf7400ae8c36d1ed238

import type { ConcreteRequest } from 'relay-runtime';
export type DataSecurityPolicyAction = "AI_ACCESS" | "ANONYMOUS_ACCESS" | "APP_ACCESS" | "APP_ACCESS_CONFIGURED" | "ATTACHMENT_DOWNLOAD" | "PAGE_EXPORT" | "PUBLIC_LINKS" | "%future added value";
export type DataSecurityPolicyDecidableContentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type useIsAttachmentDownloadDisabledQuery$variables = {
  action: DataSecurityPolicyAction;
  contentId: string;
  contentStatus: DataSecurityPolicyDecidableContentStatus;
  contentVersion: number;
  spaceKey?: string | null | undefined;
};
export type useIsAttachmentDownloadDisabledQuery$data = {
  readonly dataSecurityPolicy: {
    readonly isActionEnabledForContent: {
      readonly action: DataSecurityPolicyAction | null | undefined;
      readonly allowed: boolean | null | undefined;
    };
  } | null | undefined;
};
export type useIsAttachmentDownloadDisabledQuery = {
  response: useIsAttachmentDownloadDisabledQuery$data;
  variables: useIsAttachmentDownloadDisabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "action"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStatus"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentVersion"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "concreteType": "Confluence_dataSecurityPolicy",
    "kind": "LinkedField",
    "name": "dataSecurityPolicy",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "action",
            "variableName": "action"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
          },
          {
            "kind": "Variable",
            "name": "contentVersion",
            "variableName": "contentVersion"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          }
        ],
        "concreteType": "DataSecurityPolicyDecision",
        "kind": "LinkedField",
        "name": "isActionEnabledForContent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "action"
          },
          {
            "kind": "ScalarField",
            "name": "allowed"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsAttachmentDownloadDisabledQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsAttachmentDownloadDisabledQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "978334c7a56389878fe12e353224c5fb",
    "id": "b52b2cd2f09302e89f948c3933b5eded67abf62d74d6bcf7400ae8c36d1ed238",
    "metadata": {},
    "name": "useIsAttachmentDownloadDisabledQuery",
    "operationKind": "query",
    "text": "query useIsAttachmentDownloadDisabledQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
  }
};
})();

(node as any).hash = "c2b35f4574dc5079df90541fabaaf6f9";

export default node;
